import { ChangeDetectionStrategy, Component, inject, ViewContainerRef } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnswersStore, StatusValidation } from 'src/app/store/answers-store';
import { PopupExpenseApprovalComponent } from 'src/app/features/approvals/components/popup-expense-approval/popup-expense-approval.component';
import { MatDialog } from '@angular/material/dialog';
import { ApprovalStore } from 'src/app/features/approvals/store/approval-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { EApprovalStatus } from 'src/app/models/approval.model';
import { LogoDisplayComponent } from "../../create-questionnaire-page/component/question-board/logo-display/logo-display.component";
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { QuestionnaireStatusComponent } from "../../questionnaires/features/table-grid/features/questionnaires-list-page/components/questionnaire-status/questionnaire-status.component";
import { ErrorMessageComponent } from '../../create-questionnaire-page/component/answer-questionnarie-lower-nav/error-message/error-message.component';
@Component({
    selector: 'que-view-answer-header',
    imports: [CommonModule, TranslateDirective, TranslatePipe, SvgIconComponent, LogoDisplayComponent, QuestionnaireStatusComponent],
    templateUrl: './view-answer-header.component.html',
    styleUrls: ['./view-answer-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewAnswerHeaderComponent {
  #answersStore = inject(AnswersStore);
  #questionnaireStore = inject(QuestionnaireStore);
  #approvalStore = inject(ApprovalStore);
  #router = inject(Router);
  #location = inject(Location);
  #dialog = inject(MatDialog);
  #viewContainerRef = inject(ViewContainerRef);

  questionnaireGuid$ = toSignal(this.#answersStore.questionnaireGuid$);
  currentAnswersUser$ = toSignal(this.#answersStore.currentAnswersUser$);
  questionnaire$ = toSignal(this.#questionnaireStore.questionnaire$);
  sentDate$ = toSignal(this.#answersStore.sentDate$);
  approvalDate$ = toSignal(this.#answersStore.approvalDate$);
  recipientId$ = toSignal(this.#answersStore.recipientId$);
  status$ = toSignal(this.#answersStore.status$);
  isAnswersValid$ = toSignal(this.#answersStore.isValid$);
  enum = EApprovalStatus

  goBack() {
    this.#location.back();
  }

  respond(type: EApprovalStatus) {
    if (type === EApprovalStatus.Approved && this.isAnswersValid$() === false) {
      this.#dialog.open(ErrorMessageComponent, { data: { error: StatusValidation.NotValid } });
      return;
    }

    this.#dialog.open(PopupExpenseApprovalComponent, {
      viewContainerRef: this.#viewContainerRef,
      data: { type, name: this.questionnaire$()?.definitions?.name }
    }
    ).afterClosed().subscribe(
      x => {
        if (x) {
          this.#approvalStore.updateApprovalStatus({ guid: this.questionnaireGuid$(), status: x.status, comment: x.comment })

        }
      }
    );
  }
}
